import axios from 'axios';
import { JsonResponse } from 'core/models/response';

import { AuthorizedCapital } from '../models/raiseCapitals';

export const onGetAuthorizedCapital = async () => {
	try {
		const response = await axios.get<{ success: AuthorizedCapital }>('dashboard/actions/authorized-capital/current-authorized-capital');
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateAuthorizedCapital = async (authorized_capital: number) => {
	try {
		const response = await axios.put<JsonResponse<AuthorizedCapital>>('dashboard/actions/authorized-capital/update-authorized-capital', {
			authorized_capital,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
